import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useTrackView(nhSlug: string | undefined) {
  useEffect(() => {
    if (!nhSlug) return;

    const trackView = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        await supabase.from("nursing_home_views").insert({
          nursing_home_id: nhSlug,
          viewer_id: user?.id || null,
          source: "direct",
          page_section: "profile",
        });
      } catch (err) {
        // Silent fail - analytics should never break the page
        console.error("Failed to track view:", err);
      }
    };

    trackView();
  }, [nhSlug]);
}
